import React, { useEffect } from 'react';
import { LuX } from 'react-icons/lu';
import { COPY } from '../../contracts/copyMap';
import LegalSections, { TITLES } from './LegalSections';

// Shared Terms of Service / Privacy Policy modal. Single source for both the
// onboarding terms step and the sign-in / sign-up surface — the section
// rendering is shared with the routed public legal pages via LegalSections.
//
// `doc` is 'tos' | 'privacy' | null — null renders nothing (modal closed).
// Closes on the X button, Escape, or a click on the backdrop.
const LegalModal = ({ doc, onClose }) => {
  useEffect(() => {
    if (!doc) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [doc, onClose]);

  if (!doc) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-5 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="legal-modal-title"
        className="relative w-full max-w-xl max-h-[80vh] overflow-y-auto rounded-[22px] border border-hairline bg-[rgba(13,13,12,0.96)] p-8 md:p-10"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label={COPY.ONBOARDING_LEGAL_CLOSE}
          className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full border border-hairline text-bone-dim transition-colors hover:border-bone hover:text-bone"
        >
          <LuX aria-hidden="true" />
        </button>

        <h2
          id="legal-modal-title"
          className="m-0 pr-10 font-display text-bone"
          style={{ fontSize: '32px', lineHeight: 1.12 }}
        >
          {TITLES[doc]}
        </h2>
        <p className="mt-2 font-display italic text-bone-dim">
          {COPY.LEGAL_LAST_UPDATED}
        </p>

        <div className="mt-6">
          <LegalSections doc={doc} />
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
